import { t } from 'i18next';
import { safeCharacterName } from '../../../../../../../shared/common/utils';
import { withSiteMeta } from '../../../../../../../shared/frontend/HOCS/withSiteMeta';
import { PossibleLink } from '../../../../../../../shared/frontend/components/link';
import { ComplexTooltip } from '../../../../../../../shared/frontend/components/presentational/tooltip';
import { StreamTooltipContent } from '../../../../../../../shared/frontend/components/presentational/streamPreview';
import { ClassIcon } from '../../../../../../../shared/frontend/scripts/wow/components/ClassIcon';
import { SpecIcon } from '../../../../../../../shared/frontend/scripts/wow/components/SpecIcon';
import { getTeamLink } from '../../../../../../../shared/frontend/libs/keystoneTeams';
import { namedRoutes, resolveRoutePath } from '../../../bundles/routes';

export const KeystoneGroupMember = withSiteMeta((props: any) => {
  if (!props.character) {
    // we can legitimately be called without a character, and just need to not have anything show
    // this mainly happens when groups do not have all 5 members, as shown here:
    // http://raider.io/mythic-plus/runs/1107803
    return <span />;
  }

  const seasonAnchor =
    props.season && props.season !== props.siteConfig.currentSeasonSlug ? `?season=${props.season}` : '';

  let url: null | string = null;

  const isTransfer = props.character.name.includes('-');
  if (props.team && props.teamDetailsRoute && !props.eventNamespace) {
    url = getTeamLink(props.teamDetailsRoute, { id: props.team, members: [] }) + seasonAnchor;
  } else {
    url =
      resolveRoutePath(namedRoutes.CharacterDetails, {
        region: props.character.region.slug,
        realm: props.character.realm.slug,
        character: safeCharacterName(props.character.name)
      }) + seasonAnchor;
  }

  return (
    <ComplexTooltip
      placement="top"
      tag="span"
      tooltip={
        <div className="slds-text-align--center">
          <span className="slds-avatar slds-avatar--x-small slds-m-right--xx-small">
            <ClassIcon class={props.character.class.slug} />
          </span>
          {props.character.spec && props.character.spec.slug && (
            <span className="slds-avatar slds-avatar--x-small slds-m-right--xx-small">
              <SpecIcon class={props.character.class.slug} spec={props.character.spec.slug} />
            </span>
          )}
          <span className="slds-m-left--xx-small">
            {props.character.spec && props.character.spec.name
              ? `${props.character.spec.name} ${props.character.class.name}`
              : props.character.class.name}
          </span>
          {isTransfer && <div className="slds-text-body--small">{t('mplus-runs:tooltips.transferred-or-renamed')}</div>}
          {props.character.stream && <StreamTooltipContent type="twitch" stream={props.character.stream} count={1} />}
        </div>
      }
    >
      <span className="slds-m-right--x-small">
        {props.showRoleIcon ? (
          <span className={`slds-m-right--xx-small slds-avatar icon-role icon-small ${props.role}-lfg`} />
        ) : null}
        <span className={props.character.stream ? 'streaming-now' : ''}>
          <PossibleLink
            allowLink={!props.character.anonymized && !isTransfer}
            to={url}
            className={`class-color--${props.character.class.id}`}
          >
            {safeCharacterName(props.oldCharacter ? props.oldCharacter.name : props.character.name)}
          </PossibleLink>
        </span>
      </span>
    </ComplexTooltip>
  );
});
